// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: Step4CargoStores.css */

.nmc-step {
    padding: 2rem;
    background: #fefefe;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.tab-buttons {
    display: flex;
    margin-bottom: 1rem;
    gap: 10px;
}

    .tab-buttons button {
        flex: 1 1;
        padding: 10px 15px;
        border: 1px solid #ccc;
        background-color: #f0f0f0;
        font-weight: 600;
        cursor: pointer;
        border-radius: 4px;
        transition: 0.3s;
    }

        .tab-buttons button.active {
            background-color: #005fa3;
            color: white;
            border-color: #005fa3;
        }

.upload-section {
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

    .upload-section input[type="file"] {
        width: 100%;
    }

.fill-btn {
    background-color: #007bff;
    border: none;
    padding: 10px 14px;
    color: white;
    font-weight: bold;
    cursor: pointer;
    width: fit-content;
    border-radius: 4px;
}

    .fill-btn:hover {
        background-color: #005fa3;
    }

.list-title {
    margin-top: 2rem;
    font-size: 1.2rem;
    font-weight: 600;
    border-bottom: 2px solid #ddd;
    padding-bottom: 5px;
}

.list-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    font-size: 0.95rem;
}

    .list-table th,
    .list-table td {
        padding: 10px;
        border: 1px solid #ccc;
        text-align: left;
    }

    .list-table th {
        background-color: #f9f9f9;
        font-weight: 600;
    }

    .list-table td button {
        margin-right: 8px;
        padding: 6px 10px;
        font-size: 0.85rem;
        cursor: pointer;
        border-radius: 3px;
        border: none;
        background-color: #007bff;
        color: white;
    }

        .list-table td button.reset-btn {
            background-color: #dc3545;
        }

        .list-table td button:hover {
            opacity: 0.9;
        }

/* Modal overlay */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
    z-index: 1000;
}

.modal {
    background: white;
    width: 600px;
    max-width: 95%;
    margin: 5% auto;
    padding: 2rem;
    border-radius: 8px;
    position: relative;
}

    .modal label {
        display: block;
        margin-bottom: 10px;
        font-weight: 600;
    }

    .modal input, .modal select {
        width: 100%;
        padding: 8px;
        margin-top: 4px;
        margin-bottom: 15px;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

.modal-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

    .modal-buttons button {
        padding: 8px 16px;
        font-weight: 600;
        border: none;
        border-radius: 4px;
        cursor: pointer;
    }

        .modal-buttons button:first-child {
            background-color: #28a745;
            color: white;
        }

        .modal-buttons button.reset-btn {
            background-color: #6c757d;
            color: white;
        }

/* Progress bar */
.progress-bar {
    width: 100%;
    height: 8px;
    background-color: #e0e0e0;
    border-radius: 5px;
    margin-top: 6px;
    overflow: hidden;
}

.progress-fill {
    height: 100%;
    background-color: #28a745;
    width: 0%;
    transition: width 0.3s ease-in-out;
}
.nmc-step {
    padding: 20px;
    font-family: Arial, sans-serif;
}

.upload-controls {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}

.list-section table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}

.list-section th, .list-section td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
}

.list-section th {
    background-color: #f0f0f0;
}

button {
    margin: 5px;
    padding: 6px 12px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/demo/NMCPreArrival/steps/Step4CargoStores.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;IAEI;QACI,SAAO;QACP,kBAAkB;QAClB,sBAAsB;QACtB,yBAAyB;QACzB,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;;QAEI;YACI,yBAAyB;YACzB,YAAY;YACZ,qBAAqB;QACzB;;AAER;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;IAEI;QACI,WAAW;IACf;;AAEJ;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;IAEI;;QAEI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,YAAY;QACZ,yBAAyB;QACzB,YAAY;IAChB;;QAEI;YACI,yBAAyB;QAC7B;;QAEA;YACI,YAAY;QAChB;;AAER,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;IAEI;QACI,cAAc;QACd,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;IACtB;;AAEJ;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;IAEI;QACI,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,eAAe;IACnB;;QAEI;YACI,yBAAyB;YACzB,YAAY;QAChB;;QAEA;YACI,yBAAyB;YACzB,YAAY;QAChB;;AAER,iBAAiB;AACjB;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,SAAS;IACT,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":["/* File: Step4CargoStores.css */\n\n.nmc-step {\n    padding: 2rem;\n    background: #fefefe;\n    border-radius: 8px;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n}\n\n.tab-buttons {\n    display: flex;\n    margin-bottom: 1rem;\n    gap: 10px;\n}\n\n    .tab-buttons button {\n        flex: 1;\n        padding: 10px 15px;\n        border: 1px solid #ccc;\n        background-color: #f0f0f0;\n        font-weight: 600;\n        cursor: pointer;\n        border-radius: 4px;\n        transition: 0.3s;\n    }\n\n        .tab-buttons button.active {\n            background-color: #005fa3;\n            color: white;\n            border-color: #005fa3;\n        }\n\n.upload-section {\n    margin: 20px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n    .upload-section input[type=\"file\"] {\n        width: 100%;\n    }\n\n.fill-btn {\n    background-color: #007bff;\n    border: none;\n    padding: 10px 14px;\n    color: white;\n    font-weight: bold;\n    cursor: pointer;\n    width: fit-content;\n    border-radius: 4px;\n}\n\n    .fill-btn:hover {\n        background-color: #005fa3;\n    }\n\n.list-title {\n    margin-top: 2rem;\n    font-size: 1.2rem;\n    font-weight: 600;\n    border-bottom: 2px solid #ddd;\n    padding-bottom: 5px;\n}\n\n.list-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 10px;\n    font-size: 0.95rem;\n}\n\n    .list-table th,\n    .list-table td {\n        padding: 10px;\n        border: 1px solid #ccc;\n        text-align: left;\n    }\n\n    .list-table th {\n        background-color: #f9f9f9;\n        font-weight: 600;\n    }\n\n    .list-table td button {\n        margin-right: 8px;\n        padding: 6px 10px;\n        font-size: 0.85rem;\n        cursor: pointer;\n        border-radius: 3px;\n        border: none;\n        background-color: #007bff;\n        color: white;\n    }\n\n        .list-table td button.reset-btn {\n            background-color: #dc3545;\n        }\n\n        .list-table td button:hover {\n            opacity: 0.9;\n        }\n\n/* Modal overlay */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0,0,0,0.4);\n    z-index: 1000;\n}\n\n.modal {\n    background: white;\n    width: 600px;\n    max-width: 95%;\n    margin: 5% auto;\n    padding: 2rem;\n    border-radius: 8px;\n    position: relative;\n}\n\n    .modal label {\n        display: block;\n        margin-bottom: 10px;\n        font-weight: 600;\n    }\n\n    .modal input, .modal select {\n        width: 100%;\n        padding: 8px;\n        margin-top: 4px;\n        margin-bottom: 15px;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n    }\n\n.modal-buttons {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n}\n\n    .modal-buttons button {\n        padding: 8px 16px;\n        font-weight: 600;\n        border: none;\n        border-radius: 4px;\n        cursor: pointer;\n    }\n\n        .modal-buttons button:first-child {\n            background-color: #28a745;\n            color: white;\n        }\n\n        .modal-buttons button.reset-btn {\n            background-color: #6c757d;\n            color: white;\n        }\n\n/* Progress bar */\n.progress-bar {\n    width: 100%;\n    height: 8px;\n    background-color: #e0e0e0;\n    border-radius: 5px;\n    margin-top: 6px;\n    overflow: hidden;\n}\n\n.progress-fill {\n    height: 100%;\n    background-color: #28a745;\n    width: 0%;\n    transition: width 0.3s ease-in-out;\n}\n.nmc-step {\n    padding: 20px;\n    font-family: Arial, sans-serif;\n}\n\n.upload-controls {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.list-section table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n}\n\n.list-section th, .list-section td {\n    border: 1px solid #ccc;\n    padding: 8px;\n    text-align: left;\n}\n\n.list-section th {\n    background-color: #f0f0f0;\n}\n\nbutton {\n    margin: 5px;\n    padding: 6px 12px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
